import { render, staticRenderFns } from "./terms-links.vue?vue&type=template&id=2a5af886"
import script from "./terms-links.vue?vue&type=script&lang=js"
export * from "./terms-links.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports